import { render } from "./SavingData.vue?vue&type=template&id=78f10bac&scoped=true"
import script from "./SavingData.vue?vue&type=script&lang=js"
export * from "./SavingData.vue?vue&type=script&lang=js"

import "./SavingData.vue?vue&type=style&index=0&id=78f10bac&scoped=true&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78f10bac"]])

export default __exports__